import { useEffect, useState } from "react";
import { Phone, MapPin } from "lucide-react";
import { WhatsAppIcon, InstagramIcon } from "./Icons";
import { TEL, WA, IG, MAPS_DIR } from "../../lib/site";

const ITEMS = [
  { href: WA, label: "WhatsApp", icon: WhatsAppIcon, ext: true, id: "whatsapp", cls: "bg-emerald-800 text-white" },
  { href: TEL, label: "Telefon", icon: Phone, id: "phone", cls: "bg-emerald-950 text-gold-light" },
  { href: MAPS_DIR, label: "Konum", icon: MapPin, ext: true, id: "location", cls: "bg-emerald-950 text-gold-light" },
  { href: IG, label: "Instagram", icon: InstagramIcon, ext: true, id: "instagram", cls: "bg-emerald-950 text-gold-light" },
];

const useScrolledPast = () => {
  const [past, setPast] = useState(false);
  useEffect(() => {
    const onScroll = () => setPast(window.scrollY > window.innerHeight * 0.85);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);
  return past;
};

export const FloatingActions = () => {
  const past = useScrolledPast();
  return (
  <div
    className={`fixed bottom-[74px] right-2 z-40 flex flex-col gap-1.5 transition-[opacity,transform] duration-300 md:pointer-events-auto md:bottom-6 md:right-5 md:translate-x-0 md:gap-2.5 md:opacity-100 ${past ? "opacity-100" : "pointer-events-none translate-x-3 opacity-0"}`}
    data-testid="floating-actions"
    data-visible={past ? "true" : "false"}
  >
    {ITEMS.map(({ href, label, icon: Icon, ext, id, cls }) => (
      <a
        key={id}
        href={href}
        aria-label={label}
        data-testid={`floating-${id}`}
        {...(ext ? { target: "_blank", rel: "noopener noreferrer" } : {})}
        className={`group relative flex h-9 w-9 items-center justify-center rounded-full ring-1 ring-gold/50 shadow-[0_10px_24px_-10px_rgba(2,44,34,0.6)] transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:ring-gold md:h-11 md:w-11 ${cls}`}
      >
        <Icon className="h-4 w-4 md:h-[18px] md:w-[18px]" strokeWidth={1.8} />
        <span className="pointer-events-none absolute right-full mr-3 hidden whitespace-nowrap rounded-full bg-emerald-950 px-3 py-1 text-xs font-medium text-cream opacity-0 shadow-lg ring-1 ring-gold/30 transition-opacity duration-200 group-hover:opacity-100 md:block">
          {label}
        </span>
      </a>
    ))}
  </div>
  );
};
